import { ApiCategory, ApiImage, CatalogCategory, CatalogProduct } from '../models';

function resolveImageUrl(image: ApiImage | undefined): string {
  if (!image?.baseUrl || !image.imageBasePath) return '';
  return `${image.baseUrl}tr:w-400:h-400:di-defaultImage.jpg/${image.imageBasePath}`;
}

/** Flatten one `categoryInfo/products` payload entry into a render-ready category. */
export function toCatalogCategory(category: ApiCategory): CatalogCategory {
  const id = category.categoryInfo._id;
  const name = category.categoryInfo.name;
  return {
    id,
    name,
    imageUrl: resolveImageUrl(category.categoryInfo.image),
    products: (category.products ?? []).map((p): CatalogProduct => ({
      id: p.productInfo._id,
      name: p.metaInfo.itemName,
      skuCode: p.productInfo.skuCode,
      price: p.metaInfo.price,
      quantity: p.metaInfo.quantity,
      outOfStock: p.metaInfo.outOfStockStatus || p.metaInfo.quantity <= 0,
      imageUrl: resolveImageUrl(p.productInfo.image),
      categoryId: id,
      categoryName: name,
    })),
  };
}
